import React, { useEffect, useState } from "react";
import { ParcItem } from "./styles";
import {
  moeda,
  databoa,
  HistoricoPagamento,
  iconSelector,
} from "../../../services/utils";
import formas_api from "../../../services/formas_pagamento.json";
import GeraCobrancas from "../GeraCobrancas";
import api from "../../../services/api";
import { dataUser } from "../../../services/auth";

import { addDays, isAfter, parseISO, startOfDay } from "date-fns";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faClock,
  faCheck,
  faEyeSlash,
  faHandHoldingUsd,
  faQrcode,
} from "@fortawesome/free-solid-svg-icons";
import useClipboard from "react-use-clipboard";
import { notificar } from "../../../components/Notificador";
import { getConfigCobranca } from "../../../services/cobranca";

// `parcvencimento` é DATEONLY ("2026-08-27"): não tem hora nem fuso. Comparar
// com `new Date()` cru marcava a parcela como vencida a partir da MEIA-NOITE do
// próprio dia do vencimento — o formando perdia o boleto no dia em que ainda
// estava em dia (incidente 2026-08-27). O dia do vencimento é dia de pagar:
// vencido = passou do FIM daquele dia.
const estaVencida = (parcvencimento) =>
  isAfter(startOfDay(new Date()), startOfDay(parseISO(parcvencimento)));

// Boleto vencido continua PAGÁVEL: o BB recebe o título por N dias depois do
// vencimento (com multa e juros que ele mesmo calcula). Enquanto estiver nessa
// janela, a tela segue oferecendo o boleto em vez de escondê-lo.
const dentroDaJanela = (parcvencimento, dias) =>
  !isAfter(
    startOfDay(new Date()),
    addDays(startOfDay(parseISO(parcvencimento)), dias)
  );

export default function FinancialItem(props) {
  const { parcela } = props;
  const [isCopied, setCopied] = useClipboard(parcela.parctransacao);
  const [checkoutLoad, setCheckoutLoad] = useState(false);
  const [diasLimite, setDiasLimite] = useState(null);

  useEffect(() => {
    let vivo = true;
    getConfigCobranca().then((c) => {
      if (vivo) setDiasLimite(c.diasLimiteRecebimento);
    });
    return () => {
      vivo = false;
    };
  }, []);
  if (isCopied) {
    notificar("Chave copiada. Cole no App do seu banco.", "verde");
    notificar(
      "ATENÇÃO: Só faça o pagamento se tiver certeza de não o ter feito antes. Nosso sistema pode levar até 72hs para confirmar seu PIX.",
      "amarelo",
      "embaixo",
      null,
      null,
      10000
    );
  }

  const handleCopyClipboard = (e) => {
    e.preventDefault();
    setCopied();
  };

  // Tranche de cartão: cria a ordem na operadora sob demanda (mesma rota do
  // autocadastro) e leva ao checkout.
  //
  // SEMPRE pede uma ordem nova, mesmo com parctransacao já preenchida. O link
  // da Cielo caduca, e antes o portal reaproveitava o link salvo para sempre:
  // quando ele morria, o formando batia no "Este link de pagamento é inválido"
  // e não tinha como sair — o botão que gera outro só aparecia com o campo
  // vazio. A rota é barata e já sobrescreve parctransacao a cada chamada.
  const iniciarCheckoutCartao = async (e) => {
    e.preventDefault();
    if (checkoutLoad) return;
    setCheckoutLoad(true);
    try {
      const { data } = await api.post("/contrato/checkout", {
        aluno: dataUser().id,
        parcid: parcela.parcid,
      });
      if (data && data.checkoutUrl) {
        window.location.href = data.checkoutUrl;
        return;
      }
      notificar(
        "Não foi possível abrir o pagamento no cartão agora. Tente novamente.",
        "amarelo"
      );
    } catch (err) {
      notificar(
        "Não foi possível abrir o pagamento no cartão agora. Tente novamente.",
        "amarelo"
      );
    } finally {
      setCheckoutLoad(false);
    }
  };

  return (
    <ParcItem
      title={
        parcela.parcpagoem !== null
          ? `Pago em ${databoa(parcela.parcpagoem)} ${parcela.parcforma === 2
            ? parcela.parcorigem === "Portal"
              ? `(${parcela.parcdoc.split(" - ")[0]})`
              : "(Pagamento na produtora)"
            : ""
          }`
          : estaVencida(parcela.parcvencimento)
            ? `Vencido desde ${databoa(
              parcela.parcvencimento
            )}. Ainda não foi confirmado o pagamento.`
            : `Vence em ${databoa(
              parcela.parcvencimento
            )}. Ainda não foi confirmado o pagamento.`
      }
    >
      <span>
        {iconSelector(parcela.parcforma, formas_api)}{" "}
        {moeda(
          parcela.parcvalorpago !== 0
            ? parcela.parcvalorpago
            : parcela.parcvalor + parcela.parctaxa
        )}{" "}
        -{" "}
        <HistoricoPagamento
          vencimento={parcela.parcvencimento}
          pagoem={parcela.parcpagoem}
        />
      </span>
      <span className="partial-state">
        {parcela.parcforma === 5 && parcela.parcpagoem === null
          ? // Boleto JÁ registrado sai sempre: é 2ª via de um título vivo no BB,
            // que recebe atrasado. Sem título, ainda dá para gerar enquanto a
            // parcela estiver dentro da janela de recebimento — o registro entra
            // com a data de hoje (o BB não aceita vencimento no passado).
            // Só some quando não há mais boleto pagável: aí o caminho é a produtora.
            parcela.parclinhadigitavel ||
            !estaVencida(parcela.parcvencimento) ||
            (diasLimite !== null &&
              dentroDaJanela(parcela.parcvencimento, diasLimite)) ? (
              <GeraCobrancas
                contrato={parcela.parcconta}
                parcela={parcela}
                via={2}
                className="icon-partial pending"
              />
            ) : (
              <FontAwesomeIcon
                className="icon-partial pending"
                title="Esta parcela está vencida há muito tempo e não pode mais ser paga por boleto. Fale com a produtora."
                icon={faEyeSlash}
              />
            )
          : ""}

        {parcela.parcforma === 2 && parcela.parcpagoem === null ? (
          <a
            onClick={iniciarCheckoutCartao}
            style={{ cursor: checkoutLoad ? "wait" : "pointer" }}
          >
            <FontAwesomeIcon
              className="icon-partial pending"
              title={
                checkoutLoad
                  ? "Abrindo o pagamento no cartão…"
                  : parcela.parctransacao
                    ? "Clique para continuar o pagamento no cartão."
                    : "Clique para pagar esta parcela no cartão."
              }
              icon={faHandHoldingUsd}
              spin={checkoutLoad}
            />
          </a>
        ) : (
          ""
        )}

        {parcela.parcforma === 6 && parcela.parcpagoem === null ? (
          <a onClick={(e) => handleCopyClipboard(e)}>
            <FontAwesomeIcon
              className="icon-partial pending"
              title="Clique para copiar o código de pagamento e continuar o processo..."
              icon={faHandHoldingUsd}
            />
          </a>
        ) : (
          ""
        )}

        {parcela.parcpagoem === null ? (
          <FontAwesomeIcon
            className="icon-partial pending"
            title="Aguardando pagamento..."
            icon={faClock}
          />
        ) : (
          <FontAwesomeIcon
            className="icon-partial ok"
            title="Parcela paga"
            icon={faCheck}
          />
        )}
      </span>
    </ParcItem>
  );
}
